var _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _filter8, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _mask, _path, _path2, _g, _rect, _g2, _g3, _g4, _g5, _path3, _g6, _g7, _g8, _path4, _g9, _g10, _g11, _g12, _path5, _path6, _path7, _g13, _path8, _path9, _path10, _path11, _g14, _g15, _rect2, _rect3, _rect4, _path12, _path13, _path14, _path15, _path16, _g16, _path17, _path18, _rect5, _path19, _rect6, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 428,
    viewBox: "0 0 702 428",
    width: 702,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 75.4318,
    width: 76.2205,
    x: -16.4669,
    y: 145.156
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8863
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.250017 0 0 0 0 0.215353 0 0 0 0 0.847968 0 0 0 0.610768 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 75.4318,
    width: 76.2205,
    x: -16.4669,
    y: 191.708
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8863
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.250017 0 0 0 0 0.215353 0 0 0 0 0.847968 0 0 0 0.610768 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 75.4318,
    width: 76.2205,
    x: -16.4669,
    y: 245.11
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8863
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.250017 0 0 0 0 0.215353 0 0 0 0 0.847968 0 0 0 0.610768 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 750.955,
    width: 760.265,
    x: 104.324,
    y: -341.679
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.3029
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129427 0 0 0 0 0.224219 0 0 0 0 0.4375 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "e",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 745.846,
    width: 754.989,
    x: 111.087,
    y: -352.45
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.3029
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129427 0 0 0 0 0.224219 0 0 0 0 0.4375 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "f",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 675.234,
    width: 686.594,
    x: 153.585,
    y: -313.024
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.3029
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129427 0 0 0 0 0.224219 0 0 0 0 0.4375 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "g",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 770.9,
    width: 780.347,
    x: 101.476,
    y: -387.772
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.3029
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129427 0 0 0 0 0.224219 0 0 0 0 0.4375 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "h",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 76.6763,
    width: 151.299,
    x: 549.744,
    y: 53.2003
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.8461
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 158.148,
    x2: 525.721,
    y1: 122.068,
    y2: 355.313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1467c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9ce3"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 693.755,
    x2: 275.156,
    y1: 149.815,
    y2: -82.2182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0695b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3913b8"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5a3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2fb8ff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 694.116,
    x2: 284.233,
    xlinkHref: "#k",
    y1: 133.879,
    y2: -93.3232
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 681.82,
    x2: 311.944,
    xlinkHref: "#k",
    y1: 127.106,
    y2: -77.9193
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 704.013,
    x2: 280.513,
    y1: 114.851,
    y2: -119.899
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2fb8ff"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.7998 391.94h16.4306v16.4306h-16.4306z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46.5547 389.598h75.3071v21.1146h-75.3071z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 3.42305,
    rx: 1.71153,
    width: 75.3071,
    x: 46.5547,
    y: 407.29
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 39.982h136.922v310.263h-136.922z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 76.4011h55.0105v16.4306h-55.0105z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 101.047h69.1713v16.4306h-69.1713z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 125.693h69.1713v16.4306h-69.1713z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 174.985h55.0105v16.4306h-55.0105z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 174.985h16.4306v16.4306h-16.4306z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 198.262h60.8269v16.4306h-60.8269z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.4297 201.995h8.96217v8.96217h-8.96217z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 221.538h64.9991v16.4306h-64.9991z"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 221.538h16.4306v16.4306h-16.4306z"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 274.938h46.9194v16.4306h-46.9194z"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 274.938h16.4306v16.4306h-16.4306z"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 298.215h55.0105v16.4306h-55.0105z"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.4297 301.949h8.96217v8.96217h-8.96217z"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6914 321.491h74.7343v16.4306h-74.7343z"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6943 13.6924h36.9689v8.21532h-36.9689z"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m589.452 10.9538h42.4458v12.323h-42.4458z"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m563.437 48.608h123.914v67.5764h-123.914z"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m577.131 83.3222h16.4306v16.4306h-16.4306z"
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m605.882 79.5363h73.2533v24.0044h-73.2533z"
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 3.42305,
    rx: 1.71153,
    width: 68.461,
    x: 605.882,
    y: 100.118
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "M",
    height: 428,
    maskUnits: "userSpaceOnUse",
    width: 566,
    x: 136,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136.921.00001526h557.272c3.781 0 6.847 3.06510474 6.847 6.84610474v414.18888c0 3.781-3.066 6.846-6.847 6.846h-557.272z",
    fill: "#1a164a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 373.113h136.922v54.769h-130.07589c-3.781 0-6.84611-3.066-6.84611-6.847z",
    fill: "#000",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m26.0164 413.848c7.562 0 13.6922-6.131 13.6922-13.693s-6.1302-13.692-13.6922-13.692-13.6922 6.13-13.6922 13.692 6.1302 13.693 13.6922 13.693z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff",
      fillOpacity: 0.1,
      stroke: "#fff",
      strokeOpacity: 0.3,
      strokeWidth: 0.821532
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.0121 393.309-6.8461 6.846 6.8461 6.846 6.8461-6.846z",
    style: {
      fill: "#00cffd",
      stroke: "#000",
      strokeWidth: 0.821532,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m24.2999 400.557c-.1605-.16-.4205-.16-.581 0-.1604.161-.1604.421 0 .581l2.0747 2.075c.0771.077.1816.12.2905.12s.2134-.043.2905-.12l2.0747-2.075c.1604-.16.1604-.42 0-.581-.1605-.16-.4205-.16-.581 0l-1.3715 1.372v-4.885c0-.227-.1839-.411-.4108-.411s-.4108.184-.4108.411v4.889z",
    fill: "#000",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.6,
    height: 4.37707,
    rx: 2.18853,
    width: 45.4121,
    x: 46.5547,
    y: 389.598
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.3,
    height: 2.18853,
    rx: 1.09427,
    width: 31.7337,
    x: 46.5547,
    y: 399.538
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    fillOpacity: 0.2,
    height: 3.42305,
    rx: 1.71153,
    width: 75.3071,
    x: 46.5547,
    y: 407.29
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00cffd",
    height: 2.05383,
    rx: 1.02692,
    stroke: "#000",
    strokeOpacity: 0.05,
    strokeWidth: 0.247119,
    width: 49.2919,
    x: 47.2393,
    y: 407.974
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    fillOpacity: 0.2,
    height: 19.1691,
    rx: 3.42305,
    width: 123.23,
    x: 6.8457,
    y: 39.982
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.7418 52.5421c.691 0 1.3385-.2086 1.8773-.5649l1.9034 1.9077c.1261.1217.2869.1826.4607.1826.3607 0 .6258-.2825.6258-.6388 0-.1652-.0565-.326-.1782-.4477l-1.8904-1.899c.3911-.5519.6215-1.2298.6215-1.9599 0-1.8817-1.5384-3.42-3.4201-3.42-1.8773 0-3.42 1.5383-3.42 3.42s1.5383 3.42 3.42 3.42zm0-.9126c-1.3776 0-2.5074-1.1298-2.5074-2.5074 0-1.3732 1.1298-2.5075 2.5074-2.5075s2.5075 1.1343 2.5075 2.5075c0 1.3776-1.1299 2.5074-2.5075 2.5074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.9536 53.2418c1.4602 0 2.3945-.7475 2.3945-1.9469v-.0043c0-.93-.5389-1.4602-1.8556-1.7426l-.6823-.1521c-.8126-.1739-1.1429-.4781-1.1429-.943v-.0044c0-.591.5432-.9343 1.2776-.9343.7605-.0043 1.2516.3694 1.3342.8822l.0087.0565h.943l-.0044-.0609c-.0695-.9734-.9386-1.7252-2.2684-1.7252s-2.2685.7474-2.2728 1.8295v.0044c0 .9256.5476 1.5166 1.8208 1.786l.6867.1478c.83.1782 1.1689.491 1.1689.9734v.0044c0 .5823-.5692.9821-1.3688.9821-.8388 0-1.4428-.3651-1.495-.9343l-.0043-.0478h-.9561l.0044.0565c.0869 1.056.9952 1.773 2.4118 1.773zm5.5495-.0608c1.2081 0 1.8599-.6954 2.0164-1.3168l.0086-.0391-.9082.0043-.0174.0348c-.113.2434-.4737.5432-1.0777.5432-.7779 0-1.2733-.5258-1.2907-1.4297h3.3462v-.3303c0-1.4167-.8083-2.3684-2.125-2.3684-1.3168 0-2.1685.9865-2.1685 2.4597v.0043c0 1.4949.8343 2.438 2.2163 2.438zm-.0435-4.1284c.6388 0 1.1125.4085 1.1864 1.2515h-2.3988c.0825-.8126.5692-1.2515 1.2124-1.2515zm4.5369 4.1153c.6258 0 1.1212-.2694 1.3993-.7474h.0739v.6692h.9343v-3.2288c0-.9909-.6692-1.5819-1.8556-1.5819-1.0734 0-1.8165.5172-1.9295 1.2907l-.0043.0304h.9082l.0043-.0174c.113-.3346.4563-.5258.9778-.5258.6388 0 .9648.2868.9648.804v.4171l-1.2777.0739c-1.1255.0695-1.76.5606-1.76 1.4037v.0087c0 .8561.6649 1.4036 1.5645 1.4036zm-.6258-1.4427v-.0087c0-.4259.2955-.6606.9474-.6997l1.1516-.0739v.4042c0 .6084-.5172 1.069-1.2212 1.069-.5084 0-.8778-.2564-.8778-.6909zm4.3631 1.3645h.943v-2.8203c0-.6823.491-1.1256 1.2124-1.1256.1782 0 .339.0218.5085.0565v-.8691c-.0956-.0217-.2608-.0435-.4129-.0435-.6301 0-1.069.2955-1.2385.7953h-.0695v-.7127h-.943zm5.4277.0913c1.169 0 1.8426-.6302 2.012-1.5471l.0087-.0391h-.9039l-.0087.0217c-.1521.5085-.5171.7779-1.1081.7779-.7779 0-1.2602-.6345-1.2602-1.6774v-.0087c0-1.0169.4736-1.6427 1.2602-1.6427.6258 0 1.0082.3477 1.1125.8126l.0043.0131.9039-.0044v-.0217c-.1303-.9169-.8387-1.5862-2.025-1.5862-1.3776 0-2.2163.9344-2.2163 2.4293v.0087c0 1.5253.843 2.464 2.2206 2.464zm3.1332-.0913h.943v-2.7682c0-.7605.4303-1.2342 1.1212-1.2342.691 0 1.0169.3868 1.0169 1.169v2.8334h.9387v-3.055c0-1.1255-.5823-1.7557-1.6383-1.7557-.6867 0-1.1386.3042-1.3689.8083h-.0696v-2.5683h-.943z",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    height: 2.18853,
    rx: 1.09427,
    width: 31.7337,
    x: 6.8457,
    y: 67.3664
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.1,
    height: 19.1691,
    rx: 3.42305,
    width: 123.23,
    x: 6.8457,
    y: 75.0318
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.6,
    strokeWidth: 0.821532
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.9086 90.778h-6.1615c-.3765 0-.6846-.308-.6846-.6846v-10.9537c0-.3766.3081-.6847.6846-.6847h6.1615z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.0707 90.7784h-6.1615v-12.323h6.1615c.3765 0 .6846.3081.6846.6846v10.9538c0 .3765-.3081.6846-.6846.6846z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.4326 84.6171h4.1077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.4326 81.8789h4.1077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.4326 87.3553h4.1077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.2764 84.6171h4.1076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.2764 81.8789h4.1076"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.3,
    height: 2.18853,
    rx: 1.09427,
    width: 31.7337,
    x: 36.9678,
    y: 83.5221
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.2251 102.414c-1.602 0-3.6216 1.177-3.5874 4.217l-2.5467 3.3c-.0753.095.0137.219.1506.219l1.6978.842c.089.63.4176 2.464.5956 3.382.0616.287 2.8685.068 2.8685.068l.8216 1.664",
    style: {
      stroke: "#fff",
      strokeOpacity: 0.6,
      strokeWidth: 0.821532,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m24.544 102.552c.0765-.213-.0347-.448-.2483-.525-.2136-.076-.4487.035-.5251.248l-.6983 1.952c-.0765.213.0347.448.2483.525.2136.076.4487-.035.5251-.249zm4.2433 2.067c.1816-.136.2186-.393.0827-.575-.136-.181-.3934-.218-.575-.082l-2.3414 1.752c-.1816.136-.2186.394-.0827.575.1359.182.3934.219.575.083zm-2.6794 4.521c.0166-.226.2135-.396.4397-.379l2.2387.164c.2262.017.3962.214.3796.44s-.2135.396-.4397.379l-2.2387-.164c-.2263-.016-.3962-.213-.3796-.44zm-4.3887 3.756c-.2269 0-.4108.184-.4108.41 0 .227.1839.411.4108.411h1.8005c.2269 0 .4108-.184.4108-.411 0-.226-.1839-.41-.4108-.41zm-.4108-1.356c0-.227.1839-.411.4108-.411h.1084c-.9032-.758-2.1398-2.422-1.1293-3.752.9858-1.294 2.8548-1.294 3.8406 0 1.0095 1.329-.2188 2.995-1.1241 3.752h.1049c.2269 0 .4108.184.4108.411s-.1839.41-.4108.41h-1.8005c-.2269 0-.4108-.183-.4108-.41zm1.7269-.411v-1.751c.1893-.137.3125-.359.3125-.611 0-.416-.3372-.753-.7531-.753s-.7531.337-.7531.753c0 .277.1495.519.3722.65v1.712zm-.4553-2.429c.0058 0 .0117-.001.0177-.001h-.003c-.005 0-.01 0-.0147.001z",
    fillOpacity: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 45.8946,
    x: 36.9678,
    y: 107.872
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.9096 127.063-6.8461 6.846 6.8461 6.846 6.8461-6.846z",
    style: {
      stroke: "#fff",
      strokeOpacity: 0.6,
      strokeWidth: 0.821532,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m20.1963 134.313c-.1604-.161-.4205-.161-.5809 0-.1604.16-.1604.42 0 .581l2.0747 2.074c.0771.077.1815.121.2905.121.1089 0 .2134-.044.2904-.121l2.0747-2.074c.1605-.161.1605-.421 0-.581-.1604-.161-.4205-.161-.5809 0l-1.3715 1.371v-4.885c0-.227-.1839-.411-.4108-.411s-.4108.184-.4108.411v4.889z",
    fillOpacity: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 45.8946,
    x: 36.9678,
    y: 132.518
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.97459 166.699c1.33581 0 2.29451-.775 2.44691-1.934v-.028h-1.0148l-.0041.02c-.1484.638-.6939 1.047-1.42801 1.047-.98681 0-1.60055-.822-1.60055-2.142v-.008c0-1.316.61374-2.138 1.59653-2.138.73003 0 1.28363.453 1.43203 1.139l.0041.016h1.0148v-.032c-.1364-1.183-1.1352-2.018-2.45093-2.018-1.64065 0-2.65553 1.16-2.65553 3.037v.008c0 1.869 1.01889 3.033 2.65955 3.033zm5.39131-.056c1.3117 0 2.11-.859 2.11-2.279v-.008c0-1.412-.8023-2.27-2.11-2.27-1.3037 0-2.11.862-2.11 2.27v.008c0 1.42.7943 2.279 2.11 2.279zm0-.811c-.694 0-1.0911-.541-1.0911-1.464v-.008c0-.923.3971-1.468 1.0911-1.468.6899 0 1.0871.545 1.0871 1.468v.008c0 .923-.3931 1.464-1.0871 1.464zm4.5649.811c.6338 0 1.0791-.285 1.2837-.755h.0682v.666h.9988v-4.384h-.9988v2.555c0 .658-.345 1.075-.9908 1.075-.6017 0-.8545-.345-.8545-1.023v-2.607h-.9988v2.836c0 1.043.5054 1.637 1.4922 1.637zm3.5702-.089h.9988v-2.547c0-.626.4373-1.023 1.1032-1.023.1724 0 .3369.024.4974.056v-.894c-.0963-.028-.2528-.048-.4052-.048-.5776 0-.9788.276-1.1272.746h-.0682v-.674h-.9988zm4.9781.089c1.0791 0 1.8613-.558 1.8613-1.392v-.008c0-.638-.4051-1.003-1.2636-1.196l-.71-.156c-.4733-.109-.6579-.265-.6579-.522v-.004c0-.329.3209-.545.7662-.545.4693 0 .7582.224.8304.501l.004.012h.9386v-.008c-.0641-.71-.702-1.239-1.769-1.239-1.0349 0-1.757.545-1.757 1.335v.004c0 .646.3972 1.039 1.2315 1.224l.71.16c.4814.109.674.277.674.534v.008c0 .329-.345.553-.8424.553s-.7903-.212-.8946-.517l-.004-.008h-.9908v.008c.0842.742.7582 1.256 1.8733 1.256zm4.7455 0c1.1914 0 1.777-.686 1.9174-1.252l.0121-.036h-.9507l-.0121.028c-.0962.2-.4051.473-.9467.473-.6779 0-1.1031-.457-1.1151-1.243h3.0647v-.329c0-1.324-.7702-2.198-2.0177-2.198-1.2476 0-2.0459.902-2.0459 2.282v.004c0 1.396.7903 2.271 2.094 2.271zm-.0361-3.775c.5576 0 .9627.357 1.0309 1.075h-2.0819c.0762-.698.4934-1.075 1.051-1.075zm4.6612 3.775c1.0791 0 1.8613-.558 1.8613-1.392v-.008c0-.638-.4051-1.003-1.2636-1.196l-.71-.156c-.4733-.109-.6579-.265-.6579-.522v-.004c0-.329.3209-.545.7662-.545.4693 0 .7582.224.8304.501l.004.012h.9386v-.008c-.0641-.71-.702-1.239-1.769-1.239-1.0349 0-1.757.545-1.757 1.335v.004c0 .646.3972 1.039 1.2315 1.224l.71.16c.4814.109.674.277.674.534v.008c0 .329-.345.553-.8424.553-.4975 0-.7903-.212-.8946-.517l-.004-.008h-.9908v.008c.0842.742.7582 1.256 1.8733 1.256z",
    fill: "#fff",
    fillOpacity: 0.6
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.7797 183.2c0 4.348-3.5248 7.873-7.873 7.873-4.3481 0-7.873-3.525-7.873-7.873s3.5249-7.873 7.873-7.873c4.3482 0 7.873 3.525 7.873 7.873z",
    stroke: "#fff",
    strokeOpacity: 0.2,
    strokeWidth: 0.68461
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.8494 186.269c-1.0219.599-2.427.661-3.8406.046-1.1446-.494-2.0943-1.359-2.7031-2.347.2922.247.6331.445.9984.618 1.4599.694 2.9194.646 3.9466.001-.0006 0-.0011-.001-.0015-.001-1.4612-1.137-2.7031-2.619-3.6285-3.83-.1949-.197-.341-.444-.4871-.667 1.1202 1.038 2.898 2.347 3.531 2.718-1.3392-1.433-2.5325-3.212-2.4839-3.162 2.1187 2.174 4.0913 3.409 4.0913 3.409.0653.037.1156.069.1561.096.0427-.11.0802-.224.1117-.343.3409-1.26-.0486-2.693-.901-3.879 1.9724 1.211 3.1415 3.484 2.6543 5.386-.0127.051-.0265.102-.0414.152.0057.007.0114.014.0171.021.9739 1.235.7061 2.545.5844 2.298-.5284-1.049-1.5065-.728-2.0038-.516z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.3,
    height: 2.18853,
    rx: 1.09427,
    width: 31.7337,
    x: 36.9678,
    y: 182.106
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.7797 206.477c0 4.348-3.5248 7.873-7.873 7.873-4.3481 0-7.873-3.525-7.873-7.873s3.5249-7.873 7.873-7.873c4.3482 0 7.873 3.525 7.873 7.873z",
    stroke: "#fff",
    strokeOpacity: 0.2,
    strokeWidth: 0.68461
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.4443 206.078-2.9336 2.933 1.2015 1.202 2.9335-2.934z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m18.3115 203.459 2.3363 2.336-.0001.014c0 .33.2675.598.5975.598.3299 0 .5974-.268.5974-.598s-.2675-.597-.5974-.597h-.0187l-2.3303-2.33 4.2133.797h.0037l.7991 2.935-1.8671 1.867-2.9351-.802z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 37.5501,
    x: 36.9678,
    y: 205.086
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.7797 229.754c0 4.348-3.5248 7.873-7.873 7.873-4.3481 0-7.873-3.525-7.873-7.873s3.5249-7.873 7.873-7.873c4.3482 0 7.873 3.525 7.873 7.873z",
    stroke: "#fff",
    strokeOpacity: 0.2,
    strokeWidth: 0.68461
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.8494 232.822c-1.0219.599-2.427.66-3.8406.046-1.1446-.494-2.0943-1.359-2.7031-2.347.2922.247.6331.445.9984.617 1.4599.695 2.9194.647 3.9466.002-.0006 0-.0011-.001-.0015-.002-1.4612-1.136-2.7031-2.618-3.6285-3.829-.1949-.198-.341-.445-.4871-.667 1.1202 1.038 2.898 2.347 3.531 2.718-1.3392-1.433-2.5325-3.212-2.4839-3.163 2.1187 2.174 4.0913 3.41 4.0913 3.41.0653.037.1156.068.1561.096.0427-.11.0802-.225.1117-.343.3409-1.26-.0486-2.693-.901-3.879 1.9724 1.211 3.1415 3.483 2.6543 5.386-.0127.051-.0265.102-.0414.151.0057.007.0114.014.0171.022.9739 1.235.7061 2.544.5844 2.297-.5284-1.049-1.5065-.728-2.0038-.515z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 41.7224,
    x: 36.9678,
    y: 228.363
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.99982 266.507h1.03498v-4.918h1.785v-.87h-4.60104v.87h1.78106zm4.76148.089c.6338 0 1.0791-.285 1.2837-.755h.0682v.666h.9988v-4.384h-.9988v2.555c0 .658-.345 1.075-.9908 1.075-.6017 0-.8545-.345-.8545-1.023v-2.607h-.9988v2.836c0 1.043.5054 1.637 1.4922 1.637zm5.2951-.069c.1925 0 .377-.016.5214-.044v-.77c-.1203.012-.1965.016-.3369.016-.4172 0-.5897-.184-.5897-.622v-2.21h.9266v-.774h-.9266v-1.075h-1.0149v1.075h-.6819v.774h.6819v2.447c0 .846.4132 1.183 1.4201 1.183zm3.3695.069c1.3118 0 2.11-.859 2.11-2.279v-.008c0-1.412-.8023-2.27-2.11-2.27-1.3037 0-2.11.862-2.11 2.27v.008c0 1.42.7943 2.279 2.11 2.279zm0-.811c-.6939 0-1.0911-.541-1.0911-1.464v-.008c0-.923.3972-1.468 1.0911-1.468.69 0 1.0871.545 1.0871 1.468v.008c0 .923-.3931 1.464-1.0871 1.464zm3.1129.722h.9988v-2.547c0-.626.4372-1.023 1.1031-1.023.1725 0 .337.024.4974.056v-.894c-.0962-.028-.2527-.048-.4051-.048-.5776 0-.9788.276-1.1272.746h-.0682v-.674h-.9988zm3.9311-5.118c.325 0 .5937-.261.5937-.59 0-.325-.2687-.59-.5937-.59-.3289 0-.5977.265-.5977.59 0 .329.2688.59.5977.59zm-.5014 5.118h.9988v-4.384h-.9988zm3.4217.073c.5777 0 1.043-.249 1.2837-.674h.0682v.601h.9868v-2.996c0-.927-.6338-1.472-1.761-1.472-1.043 0-1.749.489-1.8453 1.227l-.004.036h.9427l.004-.016c.1003-.289.3971-.453.8544-.453.5375 0 .8224.241.8224.678v.377l-1.1272.068c-1.0671.064-1.6648.522-1.6648 1.304v.008c0 .798.6058 1.312 1.4401 1.312zm-.4533-1.36v-.008c0-.361.2608-.566.8184-.602l.9868-.064v.353c0 .521-.4453.914-1.047.914-.4413 0-.7582-.22-.7582-.593zm4.0315 1.287h.9988v-6.081h-.9988zm3.9191.089c1.0791 0 1.8613-.558 1.8613-1.392v-.008c0-.638-.4052-1.003-1.2636-1.196l-.71-.156c-.4734-.109-.6579-.265-.6579-.522v-.004c0-.329.3209-.545.7662-.545.4693 0 .7581.224.8303.501l.0041.012h.9386v-.008c-.0642-.71-.702-1.239-1.769-1.239-1.0349 0-1.757.545-1.757 1.335v.004c0 .646.3971 1.039 1.2315 1.224l.71.16c.4814.109.6739.277.6739.534v.008c0 .329-.3449.553-.8424.553-.4974 0-.7902-.212-.8945-.517l-.004-.008h-.9908v.008c.0842.742.7581 1.256 1.8733 1.256z",
    fill: "#fff",
    fillOpacity: 0.6
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.7797 283.153c0 4.348-3.5248 7.873-7.873 7.873-4.3481 0-7.873-3.525-7.873-7.873s3.5249-7.873 7.873-7.873c4.3482 0 7.873 3.525 7.873 7.873z",
    stroke: "#fff",
    strokeOpacity: 0.2,
    strokeWidth: 0.68461
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.8494 286.224c-1.0219.599-2.427.66-3.8406.046-1.1446-.494-2.0943-1.359-2.7031-2.347.2922.247.6331.444.9984.617 1.4599.694 2.9194.647 3.9466.002-.0006-.001-.0011-.001-.0015-.002-1.4612-1.136-2.7031-2.619-3.6285-3.829-.1949-.198-.341-.445-.4871-.667 1.1202 1.037 2.898 2.347 3.531 2.718-1.3392-1.434-2.5325-3.212-2.4839-3.163 2.1187 2.174 4.0913 3.41 4.0913 3.41.0653.037.1156.068.1561.096.0427-.11.0802-.225.1117-.343.3409-1.26-.0486-2.693-.901-3.879 1.9724 1.21 3.1415 3.483 2.6543 5.386-.0127.051-.0265.101-.0414.151.0057.007.0114.014.0171.022.9739 1.235.7061 2.544.5844 2.297-.5284-1.049-1.5065-.728-2.0038-.515z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 23.6427,
    x: 36.9678,
    y: 281.763
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.7797 306.43c0 4.348-3.5248 7.873-7.873 7.873-4.3481 0-7.873-3.525-7.873-7.873s3.5249-7.873 7.873-7.873c4.3482 0 7.873 3.525 7.873 7.873z",
    stroke: "#fff",
    strokeOpacity: 0.2,
    strokeWidth: 0.68461
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.4443 306.031-2.9336 2.933 1.2015 1.202 2.9335-2.934z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m18.3125 303.412 2.3363 2.336-.0002.014c0 .33.2675.598.5975.598s.5975-.268.5975-.598-.2675-.597-.5975-.597h-.0187l-2.3304-2.331 4.2134.798h.0037l.7992 2.935-1.8672 1.867-2.9351-.803z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    height: 2.18853,
    rx: 1.09427,
    width: 31.7337,
    x: 36.9678,
    y: 305.336
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.7797 329.707c0 4.348-3.5248 7.873-7.873 7.873-4.3481 0-7.873-3.525-7.873-7.873s3.5249-7.873 7.873-7.873c4.3482 0 7.873 3.525 7.873 7.873z",
    stroke: "#fff",
    strokeOpacity: 0.2,
    strokeWidth: 0.68461
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.4016 334.189c.8163 0 1.4788-.669 1.4788-1.493v-1.494h-1.4788c-.8163 0-1.4787.669-1.4787 1.494 0 .824.6624 1.493 1.4787 1.493z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.9229 329.709c0-.825.6624-1.494 1.4787-1.494h1.4788v2.988h-1.4788c-.8163 0-1.4787-.67-1.4787-1.494z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.9248 326.721c0-.824.6625-1.493 1.4788-1.493h1.4787v2.987h-1.4787c-.8163 0-1.4788-.669-1.4788-1.494z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.8809 325.227h1.4787c.8163 0 1.4788.669 1.4788 1.494 0 .824-.6625 1.493-1.4788 1.493h-1.4787z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8384 329.709c0 .824-.6625 1.494-1.4788 1.494s-1.4787-.67-1.4787-1.494c0-.825.6624-1.494 1.4787-1.494s1.4788.669 1.4788 1.494z"
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 51.4576,
    x: 36.9678,
    y: 328.316
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#eb6a5d",
    height: 8.21532,
    rx: 4.10766,
    width: 8.21532,
    x: 13.6943,
    y: 13.6924
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f3be4f",
    height: 8.21532,
    rx: 4.10766,
    width: 8.21532,
    x: 28.0713,
    y: 13.6924
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#64c354",
    height: 8.21532,
    rx: 4.10766,
    width: 8.21532,
    x: 42.4482,
    y: 13.6924
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m136.921.00001526h557.272c3.781 0 6.847 3.06510474 6.847 6.84610474v414.18888c0 3.781-3.066 6.846-6.847 6.846h-557.272z",
    fill: "#1a164a",
    fillOpacity: 0.63
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#M)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m650.538 156.549c26.225-64.1388 69.589-174.4606-42.57-238.6405-112.159-64.1795-164.336-23.0835-213.348-4.1567-49.012 18.9273-170.254 31.2514-152.018 107.7585 18.236 76.507 22.286 210.3017 109.405 210.3037 87.119.003 75.436-36.259 131.388-42.678 55.951-6.418 140.917 31.551 167.143-32.587z",
    fill: "url(#i)",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m650.538 156.549c26.225-64.1388 69.589-174.4606-42.57-238.6405-112.159-64.1795-164.336-23.0835-213.348-4.1567-49.012 18.9273-170.254 31.2514-152.018 107.7585 18.236 76.507 22.286 210.3017 109.405 210.3037 87.119.003 75.436-36.259 131.388-42.678 55.951-6.418 140.917 31.551 167.143-32.587z",
    fill: "#14befd",
    fillRule: "evenodd"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m261.35-54.8014c-24.603 72.099-65.006 196.0004 62.267 259.1284 127.274 63.129 181.859 14.627 234.416-9.338 52.557-23.966 184.813-45.391 159.815-128.1671-24.998-82.7765-38.16-229.3489-133.771-223.6759-95.612 5.674-80.427 44.709-141.414 55.399-60.988 10.6893-156.71-25.445-181.313 46.6536z",
    fill: "url(#j)",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m270.714-66.4772c-24.09 70.59773-63.652 191.9192 60.971 253.7332s178.072 14.322 229.535-9.144c51.462-23.467 180.965-44.445 156.487-125.4984-24.478-81.053-37.366-224.5736-130.986-219.0186-93.62 5.556-78.752 43.778-138.469 54.245-59.718 10.467-153.447-24.915-177.538 45.6828z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 6.78117,
      strokeLinecap: "round",
      strokeDasharray: "67.81 33.91",
      stroke: "url(#l)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m300.008-54.1679c-21.097 62.54762-55.701 170.0489 56.703 225.9299 112.403 55.881 160.045 14.09 206.087-6.368 46.041-20.458 162.193-38.108 139.588-110.3179-22.605-72.2097-35.279-199.8381-119.322-195.6191-84.042 4.22-70.396 38.298-123.951 47.1415-53.555 8.8436-138.009-23.3135-159.105 39.2336z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 3.39059,
      strokeLinecap: "round",
      strokeDasharray: "33.91 16.95",
      stroke: "url(#m)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m266.545-92.1607c-24.89 72.943-65.767 198.2947 62.996 262.1617 128.764 63.868 183.988 14.799 237.16-9.447s186.977-45.922 161.687-129.6676c-25.291-83.7457-38.608-232.0334-135.338-226.2944-96.73 5.74-81.368 45.232-143.069 56.047-61.702 10.815-158.545-25.743-183.436 47.2003z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 10.1718,
      strokeLinecap: "round",
      strokeDasharray: "67.81 33.91",
      stroke: "url(#n)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m573.021 26.6999c5.293 0 9.585-4.2912 9.585-9.5846s-4.292-9.58451-9.585-9.58451-9.584 4.29111-9.584 9.58451 4.291 9.5846 9.584 9.5846z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff",
      fillOpacity: 0.1,
      stroke: "#fff",
      strokeOpacity: 0.3,
      strokeWidth: 0.821532
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.868 17.1156c0 .6983-.103 1.3761-.301 2.0128-.541-1.1844-1.732-2.0128-3.122-2.0128-1.89 0-3.423 1.5336-3.423 3.4231 0 1.3898.828 2.581 2.013 3.1218-.637.1986-1.315.3012-2.013.3012-3.779 0-6.846-3.067-6.846-6.8461 0-3.779 3.067-6.8461 6.846-6.8461s6.846 3.0671 6.846 6.8461z",
    style: {
      fill: "#00cffd",
      stroke: "#000",
      strokeWidth: 0.821532,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m575.028 23.6527c-1.184-.5409-2.006-1.7321-2.006-3.115 0-.7531.24-1.4445.657-2.0128-.219-.0273-.438-.041-.657-.041-2.245 0-4.169 1.3487-5.018 3.2793 1.253 1.3486 3.033 2.1976 5.018 2.1976.698 0 1.369-.1027 2.006-.3081z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.821532
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m573.788 18.3748h.007c.377-.4655.883-.8352 1.458-1.0474.322-.4518.507-.9927.507-1.5815 0-1.5129-1.225-2.7384-2.738-2.7384s-2.739 1.2255-2.739 2.7384c0 1.513 1.226 2.7385 2.739 2.7385.267 0 .527-.0411.773-.1096",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m573.788 18.3748h.007c.377-.4655.883-.8352 1.458-1.0474.322-.4518.507-.9927.507-1.5815 0-1.5129-1.225-2.7384-2.738-2.7384s-2.739 1.2255-2.739 2.7384c0 1.513 1.226 2.7385 2.739 2.7385.267 0 .527-.0411.773-.1096",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.821532
  })), /*#__PURE__*/React.createElement("path", {
    d: "m576.445 23.9624c1.89 0 3.423-1.5326 3.423-3.4231s-1.533-3.423-3.423-3.423c-1.891 0-3.424 1.5325-3.424 3.423s1.533 3.4231 3.424 3.4231z",
    style: {
      fill: "#000",
      stroke: "#000",
      strokeWidth: 0.821532,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m574.798 20.0931 1.232 1.2323 2.054-2.0538",
    stroke: "#00cffd",
    strokeMiterlimit: 10,
    strokeWidth: 0.821532
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m590.36 20.9538h1.023v-5.31h.08l2.121 5.31h.832l2.126-5.31h.075v5.31h1.023v-7.2355h-1.293l-2.307 5.7714h-.08l-2.307-5.7714h-1.293zm11.257.1053c1.394 0 2.146-.8022 2.326-1.5193l.01-.0451-1.048.005-.02.0401c-.13.2808-.546.6268-1.243.6268-.898 0-1.469-.6067-1.489-1.6497h3.86v-.3811c0-1.6346-.932-2.7327-2.451-2.7327-1.52 0-2.503 1.1382-2.503 2.838v.0051c0 1.7249.963 2.8129 2.558 2.8129zm-.05-4.7635c.737 0 1.283.4714 1.368 1.4441h-2.767c.095-.9376.656-1.4441 1.399-1.4441zm3.74 4.6582h1.088v-3.194c0-.8775.497-1.4241 1.294-1.4241s1.173.4463 1.173 1.3489v3.2692h1.083v-3.525c0-1.2987-.672-2.0257-1.89-2.0257-.792 0-1.314.351-1.58.9326h-.08v-.8273h-1.088zm8.459 1.9205c1.545 0 2.522-.7923 2.522-2.0308v-5.3351h-1.083v.8925h-.065c-.316-.6117-.908-.9878-1.67-.9878-1.414 0-2.281 1.0981-2.281 2.6525v.0101c0 1.5343.862 2.6124 2.261 2.6124.747 0 1.349-.331 1.68-.9226h.08v1.073c0 .7421-.531 1.1633-1.429 1.1633-.737 0-1.178-.2657-1.268-.6418l-.005-.01h-1.099l-.01.01c.131.9076.983 1.5143 2.367 1.5143zm-.015-3.0838c-.928 0-1.449-.707-1.449-1.7198v-.0101c0-1.0128.521-1.7249 1.449-1.7249.918 0 1.479.7121 1.479 1.7249v.0101c0 1.0178-.556 1.7198-1.479 1.7198zm8.87 1.1633h1.123v-6.2678h2.272v-.9677h-5.671v.9677h2.276zm5.972.1053c1.595 0 2.573-1.068 2.573-2.823v-.01c0-1.755-.983-2.823-2.573-2.823-1.594 0-2.577 1.073-2.577 2.823v.01c0 1.755.978 2.823 2.577 2.823zm0-.9075c-.937 0-1.464-.707-1.464-1.9155v-.01c0-1.2084.527-1.9154 1.464-1.9154.933 0 1.464.707 1.464 1.9154v.01c0 1.2034-.531 1.9155-1.464 1.9155z",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m650.039 19.891c.152-.0043.291-.0608.404-.1825l3.303-3.3809c.095-.0957.147-.2173.147-.3607 0-.2869-.225-.5172-.512-.5172-.139 0-.274.0565-.374.1565l-2.964 3.0463-2.972-3.0463c-.1-.0956-.231-.1565-.374-.1565-.287 0-.513.2303-.513.5172 0 .1434.052.265.148.3607l3.307 3.3809c.117.1217.248.1825.4.1825z"
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.6,
    height: 8.34447,
    rx: 2.18853,
    width: 137.684,
    x: 157.463,
    y: 62.1044
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.6,
    height: 8.34447,
    rx: 2.18853,
    width: 63.9743,
    x: 157.463,
    y: 81.5748
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 129.339,
    x: 157.463,
    y: 101.045
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 95.9614,
    x: 157.463,
    y: 114.953
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 112.65,
    x: 157.463,
    y: 128.86
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.6,
    height: 4.37707,
    rx: 2.18853,
    width: 45.4121,
    x: 563.437,
    y: 48.608
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 95.9614,
    x: 563.437,
    y: 58.5481
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5b0000",
    fillOpacity: 0.22,
    height: 49.2919,
    rx: 6.8461,
    width: 123.914,
    x: 563.437,
    y: 66.8925
  })), /*#__PURE__*/React.createElement("path", {
    d: "m585.344 105.231c7.562 0 13.692-6.1305 13.692-13.6925s-6.13-13.6922-13.692-13.6922-13.693 6.1302-13.693 13.6922 6.131 13.6925 13.693 13.6925z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff",
      fillOpacity: 0.1,
      stroke: "#fff",
      strokeOpacity: 0.3,
      strokeWidth: 0.821532
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#J)",
      stroke: "#000",
      strokeWidth: 0.821532,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m588.082 91.5382-2.739-4.7923-2.738 4.7923-3.423-4.7923.684 8.8999h10.954l.685-8.8999z",
    fill: "#00cffd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m591.847 97.6996h-13.008c-.191 0-.342-.1506-.342-.3423v-1.3692c0-.1917.151-.3423.342-.3423h13.008c.192 0 .342.1506.342.3423v1.3692c0 .1917-.15.3423-.342.3423z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m579.183 86.7465c.378 0 .684-.3065.684-.6846s-.306-.6846-.684-.6846-.685.3065-.685.6846.307.6846.685.6846z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m591.506 86.746c.378 0 .685-.3065.685-.6846s-.307-.6846-.685-.6846-.685.3065-.685.6846.307.6846.685.6846z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m585.347 86.746c.378 0 .684-.3065.684-.6846s-.306-.6846-.684-.6846-.685.3065-.685.6846.307.6846.685.6846z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m609.758 89.7118c1.614 0 2.793-.9226 3.003-2.3116v-.03h-1.113l-.01.02c-.205.8173-.922 1.3288-1.88 1.3288-1.304 0-2.116-1.0781-2.116-2.7929v-.0101c0-1.7199.812-2.7979 2.111-2.7979.953 0 1.68.5766 1.89 1.4641v.0151h1.113l.005-.0251c-.19-1.4391-1.414-2.4469-3.008-2.4469-2.011 0-3.259 1.4541-3.259 3.7907v.0101c0 2.3316 1.253 3.7857 3.264 3.7857zm6.644-.0702c1.394 0 2.146-.8023 2.326-1.5193l.01-.0451-1.048.005-.02.0401c-.13.2808-.546.6268-1.243.6268-.898 0-1.469-.6067-1.489-1.6497h3.861v-.3811c0-1.6346-.933-2.7327-2.452-2.7327-1.52 0-2.503 1.1382-2.503 2.838v.005c0 1.7249.963 2.813 2.558 2.813zm-.05-4.7635c.737 0 1.283.4713 1.368 1.4441h-2.767c.095-.9377.656-1.4441 1.399-1.4441zm3.74 4.6582h1.088v-3.2542c0-.7873.567-1.2987 1.399-1.2987.206 0 .391.0251.587.0652v-1.0029c-.11-.025-.301-.0501-.476-.0501-.728 0-1.234.3409-1.43.9176h-.08v-.8224h-1.088zm6.448.0351c.211 0 .412-.0251.587-.0551v-.8675c-.15.015-.246.02-.411.02-.537 0-.757-.2406-.757-.8273v-2.8932h1.168v-.8575h-1.168v-1.3739h-1.108v1.3739h-.853v.8575h.853v3.1539c0 1.048.491 1.4692 1.689 1.4692zm2.422-6.4533c.371 0 .682-.3059.682-.6769 0-.3761-.311-.682-.682-.682-.376 0-.682.3059-.682.682 0 .371.306.6769.682.6769zm-.546 6.4182h1.083v-5.4455h-1.083zm3.053 0h1.084v-4.588h1.198v-.8575h-1.208v-.5214c0-.5516.235-.8424.837-.8424.17 0 .316.01.416.025v-.7972c-.185-.0301-.396-.0502-.642-.0502-1.133 0-1.685.5316-1.685 1.6146v.5716h-.897v.8575h.897zm4.072-6.4182c.371 0 .682-.3059.682-.6769 0-.3761-.311-.682-.682-.682-.376 0-.682.3059-.682.682 0 .371.306.6769.682.6769zm-.547 6.4182h1.084v-5.4455h-1.084zm4.96.1053c1.348 0 2.126-.7271 2.321-1.7851l.01-.0451h-1.043l-.01.0251c-.175.5866-.597.8975-1.278.8975-.898 0-1.455-.732-1.455-1.9355v-.01c0-1.1733.547-1.8954 1.455-1.8954.722 0 1.163.4012 1.283.9377l.005.015 1.043-.005v-.0251c-.15-1.058-.968-1.8301-2.336-1.8301-1.59 0-2.558 1.078-2.558 2.8029v.01c0 1.76.973 2.8431 2.563 2.8431zm5.059-.015c.722 0 1.294-.3109 1.615-.8625h.085v.7722h1.078v-3.7256c0-1.1432-.772-1.8251-2.141-1.8251-1.239 0-2.096.5966-2.227 1.4892l-.005.0351h1.048l.005-.0201c.131-.3861.527-.6067 1.129-.6067.737 0 1.113.3309 1.113.9276v.4814l-1.474.0852c-1.299.0803-2.031.6469-2.031 1.6196v.0101c0 .9878.767 1.6196 1.805 1.6196zm-.722-1.6648v-.01c0-.4914.341-.7622 1.093-.8073l1.329-.0852v.4663c0 .702-.597 1.2335-1.409 1.2335-.587 0-1.013-.2958-1.013-.7973zm7.09 1.6096c.211 0 .411-.0251.587-.0551v-.8675c-.151.015-.246.02-.412.02-.536 0-.757-.2406-.757-.8273v-2.8932h1.169v-.8575h-1.169v-1.3739h-1.108v1.3739h-.852v.8575h.852v3.1539c0 1.048.492 1.4692 1.69 1.4692zm4.082.0702c1.394 0 2.146-.8023 2.326-1.5193l.01-.0451-1.048.005-.02.0401c-.13.2808-.546.6268-1.243.6268-.898 0-1.47-.6067-1.49-1.6497h3.861v-.3811c0-1.6346-.932-2.7327-2.452-2.7327-1.519 0-2.502 1.1382-2.502 2.838v.005c0 1.7249.963 2.813 2.558 2.813zm-.051-4.7635c.738 0 1.284.4713 1.369 1.4441h-2.768c.096-.9377.657-1.4441 1.399-1.4441z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.3,
    height: 2.78149,
    rx: 1.39075,
    width: 45.8946,
    x: 605.882,
    y: 94.5977
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    fillOpacity: 0.2,
    height: 3.42305,
    rx: 1.71153,
    width: 68.461,
    x: 605.882,
    y: 100.118
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00cffd",
    height: 2.05383,
    rx: 1.02692,
    stroke: "#000",
    strokeOpacity: 0.05,
    strokeWidth: 0.247119,
    width: 41.0766,
    x: 606.566,
    y: 100.802
  })))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m136.921 34.2318h564.119v.342305h-564.119z",
    fill: "#fff",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m0 372.427h136.922v.68461h-136.922z",
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    fillOpacity: 0.2,
    height: 19.1691,
    rx: 2.73844,
    width: 25.3306,
    x: 145.139,
    y: 7.53079
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m154.084 21.5684h7.435c.943 0 1.434-.4867 1.434-1.4167v-5.2886c0-.93-.491-1.4167-1.434-1.4167h-7.435c-.939 0-1.43.4823-1.43 1.4167v5.2886c0 .93.491 1.4167 1.43 1.4167zm.056-.8648c-.4 0-.621-.2085-.621-.6301v-5.1322c0-.4215.221-.6301.621-.6301h1.982v6.3924zm7.323-6.3924c.399 0 .621.2086.621.6301v5.1322c0 .4216-.222.6301-.621.6301h-4.52v-6.3924zm-6.193 1.5905c.157 0 .287-.1347.287-.2825 0-.1477-.13-.2781-.287-.2781h-.891c-.156 0-.287.1304-.287.2781 0 .1478.131.2825.287.2825zm0 1.169c.157 0 .287-.1304.287-.2825 0-.1478-.13-.2781-.287-.2781h-.891c-.156 0-.287.1303-.287.2781 0 .1521.131.2825.287.2825zm0 1.1646c.157 0 .287-.126.287-.2781 0-.1478-.13-.2738-.287-.2738h-.891c-.156 0-.287.126-.287.2738 0 .1521.131.2781.287.2781z",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    fillOpacity: 0.2,
    height: 19.1691,
    rx: 2.73844,
    width: 23.2767,
    x: 669.55,
    y: 7.53079
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m681.183 21.9943c2.464 0 4.498-2.0338 4.498-4.4934 0-2.4597-2.038-4.4934-4.502-4.4934-2.46 0-4.489 2.0337-4.489 4.4934 0 2.4596 2.034 4.4934 4.493 4.4934zm0-.8952c-1.994 0-3.589-1.6036-3.589-3.5982 0-1.9947 1.595-3.5939 3.585-3.5939 1.995 0 3.598 1.5992 3.603 3.5939.004 1.9946-1.604 3.5982-3.599 3.5982zm-.095-2.7334c.239 0 .391-.1391.404-.3173 0-.0173 0-.0347.004-.0521.013-.2216.165-.3737.448-.5563.43-.2781.704-.5301.704-1.0299 0-.7257-.652-1.1385-1.425-1.1385-.744 0-1.252.3389-1.387.7431-.026.0782-.043.1521-.043.2303 0 .2086.165.3433.365.3433.256 0 .313-.1304.447-.2781.14-.2173.322-.3433.578-.3433.344 0 .57.1955.57.4867 0 .2651-.183.4085-.552.6605-.309.2173-.535.4389-.535.83v.0478c0 .2477.152.3738.422.3738zm-.009 1.3341c.278 0 .509-.1999.509-.478 0-.2782-.226-.4781-.509-.4781-.282 0-.513.2043-.513.4781 0 .2737.231.478.513.478z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.75a6e6f45068b00f406141a01e25cb74.svg";
export { ForwardRef as ReactComponent };